import React, { FC } from 'react';
import { SignupPage } from './SignupPage';

export const PelitasSignupPage: FC = (): JSX.Element => <SignupPage pelitas={true} />;
